module.exports = __webpack_public_path__ + "static/media/blockchain_process.acc78cc8.png";